import LqdLogo from '@components/LqdLogo';

/**
 * Full-screen branded placeholder shown while the app shell streams in and
 * Zero connects. CSS-only so it paints from the server render.
 */
export function BootSplash({ label = 'Loading' }: { label?: string }) {
  return (
    <div
      role="status"
      data-testid="boot-splash"
      className="fixed inset-0 z-50 flex items-center justify-center bg-background pt-[var(--safe-top)] pb-[var(--safe-bottom)]"
    >
      <div className="relative flex size-36 items-center justify-center">
        <span aria-hidden className="boot-splash-ring" />
        <span aria-hidden className="boot-splash-ring boot-splash-ring-delay" />
        <LqdLogo
          size="lg"
          presentation="mark"
          renderTitle={false}
          priority
          className="boot-splash-mark"
        />
      </div>
      <span className="sr-only">{label}</span>
    </div>
  );
}
